'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (palette) {
    return {
        appearance: _close2.default,
        overlayBackground: 'rgba(0, 0, 0, 0.3)',
        overlayZIndex: palette.zMaximal,
        background: palette.elPrimary,
        borderRadius: '3px',
        overflow: 'visible',
        boxShadow: '0 8px 12px 0 ' + palette.elShadow + ', 0 6px 12px 0 ' + palette.elShadow
    };
};

var _close = require('../img/close.svg');

var _close2 = _interopRequireDefault(_close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }